import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const PageHeader = ({ onOpenPopup, hideCTA = false }) => {
  const { t } = useTranslation();
  return (
    <header className="fixed top-0 w-full bg-white z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex justify-between items-center">
        <a href="/" className="flex items-center">
          <img 
            src="https://imgur.com/nYWIvWJ.png" 
            alt="Nextcoders Logo" 
            className="h-8"
            onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/150x32/1f2937/ffffff?text=Nextcoders"; }}
          />
        </a>
        <div className="flex items-center gap-4 md:gap-8">
          <LanguageSwitcher variant="compact" />
          {!hideCTA && onOpenPopup && (
            <button 
              onClick={onOpenPopup}
              className="bg-[#141414] text-white px-4 md:px-6 py-2 rounded-lg hover:bg-gray-800 transition text-sm font-semibold"
            >
              {t('common.free_diagnostic')}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default PageHeader;
